export default [{
  path: '/no-root',
  component: () => import('./no-root.vue'),
  name: 'no-root',
  meta: {
    noLimit: true
  }
}, {
  path: '/404',
  component: () => import('./index.vue'),
  name: '404',
  meta: {
    noLimit: true
  }
}];



// WEBPACK FOOTER //
// ./src/views/404/index.route.js